module.exports = __webpack_public_path__ + "static/media/incident_category-manual_incidents.8dbc6b0b.svg";